import styles from "./Facets.module.css";
import { useSearchSubmitIntent } from "./SearchSubmitIntentContext";

const FacetsApplyButton = () => {
    const { setSubmitIntent } = useSearchSubmitIntent();

    const markFacetSubmit = () => setSubmitIntent("facets");

    return (
        <button
            type="submit"
            className={styles.submitFilters}
            onPointerDown={markFacetSubmit}
            onMouseDown={markFacetSubmit}
        >
            Apply filters
        </button>
    );
};

export default FacetsApplyButton;
